module.exports = __webpack_public_path__ + "img/thumb-griffin2@2x.336d5376.png";